import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { OperandosService, Rates } from '@app/core/services/api';
import { Product } from '@app/core/services/api/model/product.model';
import { ModalService } from '@app/core/services/modal/modal.service';
import { ShoppingCartService } from '@app/core/services/shopping-cart/shopping-cart.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCTOR } from '../utils/commonMethods';
import { startWith } from 'rxjs/operators';

export interface ILabelLink {
  label: string; // Montañismo
  link: string; // /risks/montanimos
}

@Component({
  selector: 'app-tarifas-case-table',
  templateUrl: './tarifas-case-table.component.html',
  styleUrls: ['./tarifas-case-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TarifasCaseTableComponent implements OnInit, AfterViewInit {
  @ViewChild('tableEvent') tableEvent: any;
  @Input() detailCaseView = false;
  @Input() editMode = false;
  @Input() showButton = true;
  @Input() indexBlink: number;
  @Input() title: string;
  @Input() resultTable = false;
  @Input() calcDisclaimer = false;
  @Output() removeId: EventEmitter<string> = new EventEmitter();
  @Output() changeData: EventEmitter<Rates> = new EventEmitter();
  @Output() calc: EventEmitter<boolean> = new EventEmitter();
  displayedColumnsGroup: string[] = [];
  displayedColumnsMock: string[] = [];
  numRowFooter = 0;
  dataSourceMock: any[] = [];
  minWidthRow = 0;
  role = '';
  resultFooter: string[][] = [];
  _dataSource: Rates;
  operands: string[];
  public dataCard: Product = new Product({});
  literals = {
    es: 'calculador metabólico',
    en: 'metabolic calculator',
    fr: 'calculateur métabolique',
    pt: 'calculador metabólico',
    nl: 'metabolische calculator'
  };
  currentLanguage: string;
  labelCoverages: string[] = [];

  constructor(
    public cartService: ShoppingCartService,
    private translateSrv: TranslateService,
    private operandosSrv: OperandosService,
    private authSrv: AuthenticationService,
    private router: Router,
    private modalSrv: ModalService,
    private sanitazer: DomSanitizer
  ) {}
  @Input() set dataSource(value) {
    this._dataSource = value;
    this.numRowFooter = 0;
    this.initTable();
  }

  ngOnInit(): void {
    this.initTable();
  }

  initTable() {
    this.currentLanguage = this.translateSrv.currentLang;
    this.operandosSrv.operandosGet().subscribe({
      next: (data) => {
        this.operands = [...data];
      },
      error: (error) => console.log(error)
    });
    this.role = this.authSrv.getRoles()[0];
    this.displayedColumnsMock = [];
    this.labelCoverages = [];

    this.labelCoverages = [...this._dataSource.headerValues];

    this.displayedColumnsMock = this.displayedColumnsMock.concat(this.labelCoverages);
    // add col actions, esto hay que quitarlo cuando este listo el servicio
    this.displayedColumnsMock.push('actions');

    // duplicate columns to groups
    this.displayedColumnsGroup = this.displayedColumnsMock.map((value: string) => 'group_' + value);

    this.dataSourceMock = this.prepareData(this._dataSource.values);
    if (this.detailCaseView) {
      const getRowId = (row: any): string => {
        if (!Array.isArray(row) || !row.length) {
          return '';
        }
        const lastCell = row[row.length - 1];
        return typeof lastCell === 'string' ? lastCell : '';
      };

      const isFooterRow = (id: string): boolean =>
        id.includes('trash_Resultado') ||
        id.includes('trash_ResultadoMed') ||
        id.includes('trash_ResultadoDep') ||
        id.includes('trash_ResultadoOcu') ||
        id.includes('trash_ResultadoRes');

      // Si no existe ninguna fila de riesgo (solo vienen filas Resultado/Final), no mostramos el footer.
      const hasBodyRows = (this.dataSourceMock || []).some((row) => {
        const id = getRowId(row);
        return !!id && !isFooterRow(id);
      });

      if (!hasBodyRows) {
        this.dataSourceMock = (this.dataSourceMock || []).filter((row) => {
          const id = getRowId(row);
          return !id || !isFooterRow(id);
        });
        this.resultFooter = [];
        return;
      }
      this.resultFooter = this.dataSourceMock.splice(this.dataSourceMock.length - 6, 6);
    }
  }

  addEvents() {
    if (this.tableEvent?._elementRef?.nativeElement) {
      this.tableEvent?._elementRef?.nativeElement.querySelectorAll('[\\(click\\)]').forEach((element) => {
        let click = element.getAttribute('(click)');
        if (click.indexOf('redirectRate(\'') !== -1) {
          click = click.replace('redirectRate(\'', '').replace('\')', '');
        }
        element.addEventListener('click', () => {
          this.redirectRate(click);
        });
      });
    }
  }

  linkedRisk(element: any) {
    return element && typeof element === 'object' && element.changingThisBreaksApplicationSecurity.includes('(click)="');
  }

  getResultFooter(header: string, indexHeader: number) {
    if (header === 'actions') {
      this.numRowFooter += 1;
      if (this.numRowFooter === this.resultFooter.length) {
        this.numRowFooter = 0;
      }
      return '';
    } else {
      if (this.resultFooter && this.numRowFooter < this.resultFooter.length) {
        return this.resultFooter[this.numRowFooter][indexHeader];
      }
    }
  }

  ngAfterViewInit() {
    if (this.indexBlink > -1) {
      const row = document.getElementsByClassName('mat-row')[this.indexBlink];
      row.className += ' blink';
      row.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
    this.addEvents();
  }

  isParent(index, item): boolean {
    return item?.isParent;
  }

  sanitizerHtml(value: string) {
    const parser = new DOMParser();
    const document = parser.parseFromString(value, 'text/html');
    return this.sanitazer.bypassSecurityTrustHtml(document.body.outerHTML);
  }

  checkAndTransformLinkData(data: any[]) {
    data.forEach((item, index) => {
      if (typeof item === 'object' && item?.changingThisBreaksApplicationSecurity === undefined) {
        if (item && item.label) {
          let label = item.label;
          if (typeof item.label === 'object') {
            label = item.label[this.translateSrv.currentLang];
          }
          const html = `<a (click)="redirectRate('${item.link}')" >${label}</a>`;
          data[index] = this.sanitizerHtml(html);
        } else {
          if (item && item[this.translateSrv.currentLang]) {
            data[index] = item[this.translateSrv.currentLang];
          } else {
            data[index] = '';
          }
        }
      }
    });
  }

  redirectRate(item) {
    this.calc.emit(true);
    this.router.navigateByUrl('/' + item);
  }

  prepareData(data: any[]) {
    const newData: any[] = [];
    for (const v of data) {
      let copyValues = [...v.values];
      const isBoldHeader = /<b>.*<\/b>/.test(copyValues[0]);
      if (isBoldHeader) {
        newData.push(copyValues);
      } else {
        copyValues = copyValues.map((value: string, index: number) => (value === '' && index > 2 ? '-' : value));
        if (['RATE.RESULT', 'RATE.FINALRESULT', 'RATE.RESULTMED', 'RATE.RESULTDEP', 'RATE.RESULTOCU', 'RATE.RESULTRES'].includes(copyValues[0])) {
          copyValues[0] = `<div class="cps-0">${this.translateSrv.instant(copyValues[0])}</div>`;
        }
        this.checkAndTransformLinkData(copyValues);
        newData.push(copyValues.concat('trash_' + v.id));
      }
    }
    return newData;
  }

  isResidentialRow(element: any[]): boolean {
    if (!Array.isArray(element) || !this.displayedColumnsMock?.length) {
      return false;
    }
    const lastCell = element[this.displayedColumnsMock.length - 1];
    if (!lastCell || typeof lastCell !== 'string') {
      return false;
    }
    // El id se guarda como 'trash_<id>' en la última celda.
    return lastCell.startsWith('trash_residencial_') || lastCell === 'residencial' || lastCell.startsWith('residencial_');
  }

  editableRow(element: any[]): boolean {
    const lastCell = element[this.displayedColumnsMock.length - 1];
    if (!lastCell || !lastCell.startsWith('trash_')) {
      return false;
    }
    return true;
  }

  getNgModel($event: any, id: string, indexHeader: number, data: any[]) {
    for (const v of data) {
      if (v.children) {
        this.getNgModel($event, id, indexHeader, v.children);
      } else {
        if ('trash_' + v.id === id) {
          v.values[indexHeader] = $event.target.value;
          this.changeData.emit(this._dataSource);
        }
      }
    }
  }

  addSelectOption(event: MatAutocompleteSelectedEvent, id: string, indexHeader: number, data: any[]) {
    for (const v of data) {
      if (v.children) {
        this.addSelectOption(event, id, indexHeader, v.children);
      } else {
        if ('trash_' + v.id === id) {
          v.values[indexHeader] = v.values[indexHeader] + event.option.getLabel();
          this.changeData.emit(this._dataSource);
        }
      }
    }
  }

  normalizeText(text: string): string {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  includesLiteral(item: string, lang: string): boolean {
    const literal = this.literals[lang];
    return this.normalizeText(item).includes(this.normalizeText(literal));
  }

  remove(id: string) {
    this.removeId.emit(id.replace('trash_', ''));
  }

  disabledActions() {
    return false;
  }

  getTitleDescById(id: string, data: any[], dataCard: any) {
    for (const m of data) {
      if (id?.includes('CALC_MEL')) {
        dataCard.description = this.title;
      } else {
        if (id?.includes(m.id)) {
          if (dataCard.parentId === id) {
            dataCard.name = this.title ? this.title : id.split('_')[0];
            break;
          } else {
            dataCard.description = dataCard?.description
              ? this.removeHtml(m.values[this._dataSource.stickyColsStart - 1]) + ' > ' + dataCard.description
              : this.removeHtml(m.values[this._dataSource.stickyColsStart - 1]);
            this.getTitleDescById(dataCard.parentId, this._dataSource['values'], dataCard);
          }
        } else if (m.children?.length > 0) {
          dataCard.parentId = m.id;
          this.getTitleDescById(id, m.children, dataCard);
        }
      }
    }
    return null;
  }

  removeHtml(html: string) {
    const firstRegex = new RegExp(/<div class="cps-\d">/g);
    const secongRegex = new RegExp(/<\/div>/g);
    return html.replace(firstRegex, '').replace(secongRegex, '');
  }

  getTitleDesc(id: string): Product {
    const dataCard = {
      id,
      parentId: '',
      description: '',
      name: ''
    };
    this.getTitleDescById(id, this._dataSource['values'], dataCard);
    delete dataCard.parentId;
    return new Product(dataCard);
  }
}
